import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import {
  getMainStockThunk,
  mainStockSelector,
} from "store/reducers/inventory/stock/mainStockSlice";
import StockListCommons from "../StockListCommons";
import ReturnMainStock from "./menu/ReturnMainStock";
import TransferMainStock from "./menu/TransferMainStock";
import { Box, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const MainStockList = () => {
  useEffect(() => {
    dispatch(getMainStockThunk());
  }, []);
  const navigate = useNavigate();
  const roles = useSelector((state) => state.auth.user.roles);
  const items = useSelector(mainStockSelector.selectAll);
  const [returnOpen, setReturnOpen] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [stock, setStock] = useState(null);
  const openMainStockReturn = (item) => {
    setReturnOpen(true);
    setStock(item);
  };
  const openTransfer = (item) => {
    setTransferOpen(true);
    setStock(item);
  };

  return (
    <Box>
      <Stack marginBottom={2} direction="row" justifyContent="space-between">
        <Button
          variant="outlined"
          onClick={() => {
            navigate("logs");
          }}
        >
          View transaction logs
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            navigate("history");
          }}
        >
          View stock history
        </Button>
      </Stack>
      <StockListCommons
        items={items}
        openStockReturn={openMainStockReturn}
        openTransfer={openTransfer}
        stock={stock}
        returnOpen={returnOpen}
        transferOpen={transferOpen}
        setReturnOpen={setReturnOpen}
        setTransferOpen={setTransferOpen}
        ReturnStock={ReturnMainStock}
        TransferStock={TransferMainStock}
        hasEditPermissions={roles.includes("super_admin")}
      />
    </Box>
  );
};

export default MainStockList;
